import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';

Vue.use(Vuex);

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGOUT = 'LOGOUT';
const SET_ROLE = 'SET_ROLE';
const DYN_CON_DONE = 'DYN_CON_DONE';

export default new Vuex.Store({
    state: {
        contents: {
            holidays: [],
            data: [],
            prestationOptions:[],
            configData: [],
            configFilterData: [],
            orderDbHash: null,
        },
        isDynContentLoaded: false,
        isLoggedIn: false,
        isAdmin: false,
        userRole: null,
        appRootPath: null,
        UserLogin: null
    },
    getters: {
        getUserRole(state) {
            return state.userRole;
        },
        isDynContLoaded(state){
           return state.isDynContentLoaded;
        },
    },
    mutations: {
        [LOGIN_SUCCESS](state, login) {
            state.isLoggedIn = true;
            state.UserLogin = login;
        },
        [SET_ROLE](state, userRight) {
            switch (userRight) {
                case 'admin':
                    state.userRole = 'admin';
                    state.appRootPath = '/admin/dashboard';
                    state.isAdmin = true;
                    break;
                case 'referent':
                    state.userRole = 'referent';
                    state.appRootPath = '/admin/dashboard';
                    state.isAdmin = true;
                    break;
                case 'clerc':
                    state.userRole = 'clerc';
                    state.appRootPath = '/office/welcome';
                    state.isAdmin = false;
                    break;
                case 'etude':
                    state.userRole = 'etude';
                    state.appRootPath = '/office/welcome';
                    state.isAdmin = false;
                    break;
                default:
                    break;
            }
            return state.userRole
        },
        [LOGOUT](state) {
            state.isLoggedIn = false;
            state.userRole = null;
            state.appRootPath = '/';
            state.isAdmin = false;
        },
        [DYN_CON_DONE](state) {
            state.isDynContentLoaded = true;
        },
        
    },
    actions: {
        login({ state, commit }, creds) {
            //console.log("actions: login");
            commit(LOGIN_SUCCESS, creds.login);
            commit(SET_ROLE, creds.user_right);
            // FIXME: transform this into a promise for more control
            // return new Promise(resolve => {
            //   resolve();
            // });
        },
        logout({ state, commit }) {
            commit(LOGOUT);
        },
        dynContentLoaded({ state, commit }) {
            commit(DYN_CON_DONE);
        }
    },
    modules
});



// WEBPACK FOOTER //
// ./src/store/index.js